import React, {Component} from "react";

const Banner = ()=>{
    return (
    <div>
        <div className="row">
            <div
                className="col"
                style={{
                    padding: 10,
                    backgroundColor: "rgb(0, 88, 161)",
                    color: "white",
                    marginLeft: 15,
                    marginBottom: 1
                }}
            >
                <p><b>Important Notice: Terms & Conditions Update</b></p>
                <p>
                    Our Terms & Conditions are updated: sub-clause 6.6 (v) on data confidentiality has been added. By continuing to access our services, you agree to this update. Contact us with any questions.
                </p>
            </div>
        </div>
    </div>
);

}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.jsx